import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class B2bDeductionInfoComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/deduction-info';
  }
}
